export const getUserLanguageQuery = () => `
query getUserLanguage {
    userPreferences {
        language {
            languageName
        }
    }
}`;

export const saveUserLanguageMutation = () => `
mutation saveLanguage($language: UserLanguageInput!) {
    saveLanguage(language: $language)
}`;
